export { BenchRoute as default } from 'common';
